// 0 - rascunho / 1 - pendente / 2 - aprovado / 3 - rejeitado

export const PROJECT_STATUS_RASCUNHO = 0;
export const PROJECT_STATUS_PENDENTE = 1;
export const PROJECT_STATUS_APROVADO = 2;
export const PROJECT_STATUS_REJEITADO = 3;

const allStatus = [];
allStatus[PROJECT_STATUS_RASCUNHO] = {
  name: 'Rascunho',
  icon: {
    name: 'file-alt',
  },
};
allStatus[PROJECT_STATUS_PENDENTE] = {
  name: 'Pendente',
  icon: {
    name: 'clock',
  },
};
allStatus[PROJECT_STATUS_APROVADO] = {
  name: 'Aprovado',
  icon: {
    name: 'check',
  },
};
allStatus[PROJECT_STATUS_REJEITADO] = {
  name: 'Rejeitado',
  icon: {
    name: 'file-excel',
  },
};

function getName(index) {
  if (index < allStatus.length) {
    return allStatus[index].name;
  }
  return null;
}

function getIcon(index) {
  if (index < allStatus.length) {
    return allStatus[index].icon;
  }
  return null;
}

export { allStatus, getName, getIcon };
